module.exports = __webpack_public_path__ + "img/75621.2f64c846.svg";